import { z } from "zod";
import { ZUid, zUid } from "src/types/zUid";
import { zNotifyTemplate } from "../NotifyTemplates/ZNotifyTemplate";

export const zDelayedNotify = zNotifyTemplate.omit({ roleIds: true }).extend({
  roleIds: zUid.array().nullish(),
  receiverAttrIds: zUid.array().optional().nullish(),
  departmentAttrId: zUid
    .optional()
    .nullish()
    .describe("Атрибут подразделения, которому будет отправлено уведомление"),
  days: z.number(),
});

export type ZDelayedNotify = z.infer<typeof zDelayedNotify>;

export type ZDelayedNotifyToSave = Omit<ZDelayedNotify, "id"> & {
  id?: ZUid;
};
